// extracted by mini-css-extract-plugin
module.exports = {"root":"Homepage_root__3L1PJ","h1":"Homepage_h1__30WFm","h3":"Homepage_h3__CMbbI","video":"Homepage_video__3x8iR","content":"Homepage_content__2RemR"};